import { useEffect, useState } from 'react'
import { Loader } from './components/Loader/Loader'
import { ErrorMonitoring } from 'ErrorMonitoring/ErrorMonitoring'
import { BaseRoutes } from './components/app/BaseRoutes'
import { FeatureFlags } from './featureFlags/FeatureFlags'
import { getCurrentLocale } from 'translations/i18n'
import { redirectIfNeeded } from 'redirect/redirectIfNeeded'
import { NATIVE_APP_HELPER } from 'constants/native_app_helper.constants'
import { loadStateFromStorage } from 'helpers/localStorageHelper'
import { AppProviders } from 'AppPoviders'
import { Environment } from 'Environment'

export const AppIndex = () => {
  console.log('Version:', Environment.VERSION)
  getCurrentLocale()

  const [redirect, setRedirect] = useState<any>()
  const [isLoading, setIsLoading] = useState(true)

  const isNative =
    NATIVE_APP_HELPER.IS_NATIVE_PLATFORM ||
    !!loadStateFromStorage('isMobileApp')

  useEffect(() => {
    const pathname = window.location.pathname
    if (pathname.includes('login/callback')) {
      setIsLoading(false)
    }
    if (!isNative) {
      redirectIfNeeded()
        .then((result) => {
          setRedirect(result)
          setIsLoading(false)
        })
        .catch((err) => {
          console.error('redirect err', err)
          setIsLoading(false)
        })
    }
    if (isNative) setIsLoading(false)
  }, [window.location, isNative])

  if (isLoading) {
    return <Loader />
  }

  if (!redirect || redirect === null) {
    return (
      <ErrorMonitoring>
        <AppProviders>
          <FeatureFlags />
          <BaseRoutes />
        </AppProviders>
      </ErrorMonitoring>
    )
  }
  return null
}
